import { AxiosPromise } from "axios";
import configs from "../configs";
import { PortalLiveApi } from "./live/PortalLiveApi";



export class PortalApis {
    private static portalApi: PortalLiveApi = new PortalLiveApi();


    // ==================== PUBLIC ====================

    static register(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.portalApi.registerPartner(data);
        }
    }


    // ==================== INVOICES ====================

    static getInvoices(status?: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.portalApi.getInvoices(status);
    }

    static getInvoice(id: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.portalApi.getInvoice(id);
    }

    static downloadInvoice(id: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.portalApi.downloadInvoice(id);
    }

    static login(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.portalApi.loginPartner(data);
        }
    }

    static forgotPassword(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.portalApi.forgotPassword(data);
        }
    }

    // ==================== SESSION ====================

    static session(): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.portalApi.portalSession();
        }
    }

    static logout(): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.portalApi.logoutPartner();
        }
    }

    // ==================== PROFILE ====================

    static getProfile(): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.portalApi.getProfile();
        }
    }

    static updateProfile(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.portalApi.updateProfile(data);
        }
    }

    // ==================== DASHBOARD ====================

    static getDashboard(): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.portalApi.getDashboard();
        }
    }

    // ==================== API KEYS ====================

    static getApiKeys(): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.portalApi.getApiKeys();
        }
    }

    static requestKeyRotation(keyId: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.portalApi.requestKeyRotation(keyId);
        }
    }

    // ==================== USAGE ====================

    static getUsage(period: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.portalApi.getUsage(period);
        }
    }

    static getUsageDaily(period: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.portalApi.getUsageDaily(period);
        }
    }

    // ==================== WALLET ====================

    static getWallet(): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.portalApi.getWallet();
        }
    }

    static getWalletTransactions(page: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.portalApi.getWalletTransactions(page);
        }
    }

    // ==================== WEBHOOKS ====================

    static getWebhooks(): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.portalApi.getWebhooks();
        }
    }

    static createWebhook(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.portalApi.createWebhook(data);
        }
    }

    static updateWebhook(id: any, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.portalApi.updateWebhook(id, data);
        }
    }

    static deleteWebhook(id: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.portalApi.deleteWebhook(id);
        }
    }

    static testWebhook(id: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.portalApi.testWebhook(id);
        }
    }

    // ==================== DOCS ====================

    static getQuickStart(): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.portalApi.getQuickStart();
        }
    }


    // ==================== API KEY REVEAL + REGENERATE ====================

    static revealApiKey(keyId: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.portalApi.revealApiKey(keyId);
        }
    }

    static regenerateApiKey(keyId: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.portalApi.regenerateApiKey(keyId);
        }
    }


}